export default {"src":"/_next/static/media/Ramp_Logo.02d6bee3.svg","height":28,"width":101,"blurWidth":0,"blurHeight":0};